import { TextField, ReferenceField, FunctionField } from "react-admin";
import { EmptyState } from "../components/EmptyState";
import { joinAddressLine } from "../components/raFormat";
import {
  AppList,
  AppListDefaultActions,
  AppListFilterCard,
  AppDatagrid,
  AppRowActions,
  SearchFilterInput,
  ListEditButton,
} from "@/adapters/inbound/layout";

export const ClientList = () => (
  <AppList
    perPage={25}
    sort={{ field: "name", order: "ASC" }}
    empty={
      <EmptyState
        title="Keine Kunden"
        hint="Legen Sie den ersten Kunden an, um Kontaktdaten, Einsatzorte und Aufträge übersichtlich zu verwalten."
      />
    }
  >
    <AppListDefaultActions />

    <AppListFilterCard
      search={<SearchFilterInput source="q" label="Suche" />}
    />

    <AppDatagrid rowClick="show">
      <TextField source="name" label="Name" sortable />
      <TextField
        source="contactName"
        label="Ansprechpartner"
        sortable={false}
      />
      <TextField source="phone" label="Telefon" sortable={false} />
      <TextField source="email" label="E-Mail" sortable={false} />

      <ReferenceField
        source="addressId"
        reference="addresses"
        link={false}
        label="Adresse"
      >
        <FunctionField render={(address: any) => joinAddressLine(address)} />
      </ReferenceField>
      <AppRowActions>
        <ListEditButton />
      </AppRowActions>
    </AppDatagrid>
  </AppList>
);
